<template>
  <div id="mobile-nav-bar" class="nav-bar" @click="toggleContents">
    <img id="mobile-nav-bar__logo" :src="companyLogo">
    <div id="mobile-nav-button" class="nav-menu-button"><feather-icon icon="menu" /></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import FeatherIcon from '../FeatherIcon.vue'

export default {
  components: {
    FeatherIcon
  },
  data () {
    return {
      
    }
  },
  computed: {
    ...mapGetters([
        'title',
        'companyLogo',
        'showContents'
    ]),

  },
  methods: {
    ...mapMutations({
      toggleContents: 'TOGGLE_CONTENTS'
    }),
  }
}
</script>

<style scoped>
  .nav-bar {
    position: fixed;
    width: 100vw;
    background-color: #f11e22;
    color: #fff;
    border-bottom: 1px solid rgba(51, 51, 51, 0.1);
    cursor: pointer;
    height: 45px;
    padding: 10px;
    z-index: 1;
  }

  .nav-title {
    line-height: 25px;
    display: inline-block;
  }
  .nav-menu-button {
    float: right;
  }

  #mobile-nav-bar__logo {
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/mobile/MobileNavigationBar.vue